import { EventCategories, EventActions } from '../constants/Analytics';
import { createAction } from 'redux-actions';
import ActionTypes from '../constants/ActionTypes';

const analytics = createAction(ActionTypes.ANALYTICS, () => null, event => ({ event }));

/**
 * Submit the selection
 */
export function submitSelection(value, category, source) {
  category = category || {};
  const path = `/${category.key ? `find/${category.key}/` : ''}get_quotes_simple`;

  return dispatch => {
    dispatch(
      analytics({
        category: EventCategories.ARTICLES,
        action:
          source === 'hero'
            ? EventActions.GET_QUOTES_HERO_SUBMIT_FORM
            : EventActions.GET_QUOTES_WIDGET_SUBMIT_FORM,
        label: `[${path}] - [${value}]`
      })
    );
    window.location.href = getGetQuotesFormUrl(path, value);
  };
}

export default {
  submitSelection
};

export function getGetQuotesFormUrl(formPath, value) {
  if (formPath === undefined || formPath === '') {
    return '/';
  }

  if (value === undefined || value === '') {
    return formPath;
  } else {
    return `${formPath}?w=${value}`;
  }
}
